export const SET_TOKEN = "AUTH/SET_TOKEN";
export const SET_REFRESH = "AUTH/SET_REFRESH";
export const SET_SESSION = "AUTH/SET_SESSION";
export const SET_USER_DATA = "AUTH/SET_USER_DATA";
export const AUTH_LOGOUT = "AUTH/AUTH_LOGOUT";
export const SET_ATTACHMENTS = "AUTH/SET_ATTACHMENTS";
export const SET_VERIFICATION_METHODS = "AUTH/SET_VERIFICATION_METHODS";
export const SET_USER_VERIFICATION_METHOD = "AUTH/SET_USER_VERIFICATION_METHOD";
